<template>
  <section id="ruta" class="parada" v-if="druta">
    <div class="resume">
      <div class="columns is-mobile is-vcentered route detail info">
        <div class="column is-8 has-text-left name pl-0">
          <h4 class="has-text-weight-bold has-text-caxton-blue is-size-5">
            {{ horaParada }}h - {{ nombreParada }}
          </h4>
        </div>
        <div class="column">
          <p class="has-text-caxton-blue is-size-3"></p>
        </div>
        <div
          class="column is-1 has-text-center previous pl-0"
          @click="previous"
          v-if="parseInt(orden) > 2"
        >
          <b-image
            :src="require('@/assets/images/ico-previous-stop.png')"
            alt="Previous"
          ></b-image>
        </div>
        <div
          class="column is-1 has-text-right next pr-0"
          @click="next"
          v-if="
            parseInt(orden) <
              this.druta.paradas.filter(pa => pa.orden !== 100).length
          "
        >
          <b-image
            :src="require('@/assets/images/ico-next-stop.png')"
            alt="Next"
          ></b-image>
        </div>
        <div
          class="column is-1 has-text-right next pr-0"
          @click="backParada"
          v-else
        >
          <b-image
            :src="require('@/assets/images/ico-next-stop.png')"
            alt="Next"
          ></b-image>
        </div>
      </div>
      <div class="columns is-mobile route detail numbers">
        <div class="column is-2 has-text-left stops pl-0">
          <h3 class="has-text-weight-bold has-text-caxton-blue">
            <span class="now">{{ totalHanBajadoParada }}</span
            >/<span class="total">{{ totalParada }}</span>
          </h3>
        </div>
        <div class="column is-10 has-text-right passengers pr-0">
          <h3 class="has-text-weight-extra-light has-text-caxton-blue">
            <span class="aboard">{{ totalHanBajado }}</span
            >/<span class="total">{{ totalRuta }}</span>
          </h3>
        </div>
      </div>
    </div>
    <div class="passengers"></div>
    <div
      class="columns is-mobile is-multiline route detail passengers mt-6"
      v-if="trasladadosParada.length > 0"
    >
      <div
        :class="{
          column: true,
          'is-5': true,
          'is-offset-2': index % 2 == 1,
          last: trasladadosParada.length - index <= 2,
          'pl-0': true,
          'pr-0': true,

          passenger: true,
          aboard: tr.ausente == 3
        }"
        v-for="(tr, index) in trasladadosParada"
        :key="tr.id"
      >
        <div class="columns is-mobile">
          <div class="column is-3 photo pl-0" @click="bajaBus(tr)">
            <b-image
              :src="imgurl + tr.expediente + '.jpg'"
              :src-fallback="require('@/assets/images/no-photo-blue.png')"
              alt="Next"
              ratio="1by1"
              rounded
              @error="onErrorPic"
            ></b-image>
          </div>
          <div class="column is-6 name" @click="bajaBus(tr)">
            <p :style="safeguardingStyle(tr.safeguarding)">
              <span class="lastname has-text-weight-bold">
                {{ tr.nombrecompleto.split(",")[0] }}
              </span>
              <span class="firstname">
                {{ tr.nombrecompleto.split(",")[1] }}
              </span>
              <br />
              <span class="age"> {{ tr.codigocurso }}-{{ tr.tutoria }} </span>
            </p>
          </div>
          <div
            class="column is-3 icons has-text-right pr-0"
            @click="passengerDetail(tr)"
          >
            <b-image
              :src="require('@/assets/images/ico-alergias-blue.png')"
              v-show="tr.iconalergiasoenfermedades"
              alt="Alergias o Enfermedad"
            ></b-image>
            <b-image
              :src="
                require('@/assets/images/ico-sillita-' +
                  (tr.usasilla == 1 ? 'blue' : 'grey') +
                  '.png')
              "
              alt="Usa Silla"
              v-show="tr.usasilla == 1"
            ></b-image>
            <b-image
              :src="
                require('@/assets/images/ico-autorizado-' +
                  (tr.autorizadobajarsolo == 1 ? 'blue' : 'grey') +
                  '.png')
              "
              alt="Autorizado Bajar Solo"
              v-show="tr.autorizadobajarsolo == 1"
            ></b-image>
            <b-image
              :src="require('@/assets/images/ico-info-blue.png')"
              alt="Autorizado Bajar Solo"
              v-show="
                !tr.iconalergiasoenfermedades &&
                  tr.usasilla != 1 &&
                  tr.autorizadobajarsolo != 1
              "
            ></b-image>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="isComponentModalActive"
      trap-focus
      full-screen
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
      animation="slide-bottom"
      custom-class="passenger"
    >
      <template #default="props">
        <Passenger
          @close="props.close"
          :tr="detallealumno"
          :imgpic="imgurl + detallealumno.expediente + '.jpg'"
        ></Passenger>
      </template>
    </b-modal>
  </section>
</template>

<script>
import Passenger from "@/components/Passenger.vue";
export default {
  name: "Parada",
  components: {
    Passenger
  },
  mounted() {
    this.druta = this.$store.getters.detalleruta;
    this.$store.commit("SET_NAVBACK", {
      text: this.$store.getters.detalleruta.idruta,
      url: "/ruta-detalle/" + this.$store.getters.rutactiva
    });
  },
  updated() {
    if (this.druta.paradas.filter(pr => pr.orden == this.orden).length == 0) {
      this.$buefy.dialog.confirm({
        title: "A V I S O - ERROR !",
        message:
          "<strong>ERROR</strong> El orden <strong>real</strong> de la ruta tiene correspondencia con los datos obtenidos de base de datos. <br />No se van a poder realizar acciones para esta parada. " +
          " <br />----Orden: " +
          this.orden +
          " ----- <p><strong>Por favor, Notifique al administrador para que sea corregido</strong></p>",
        onConfirm: () => {
          this.$router.push("/parada/" + (this.orden - 1));
        },
        type: "is-danger"
      });
    }
  },

  methods: {
    cargaParada() {},

    bajaBus(tr) {
      //Marca o desmarca si un alumno ha bajado al autobús
      let alum = this.druta.trasladados.filter(gr => gr.id == tr.id)[0];
      if (alum.ausente == 3) {
        alum.ausente = 2;
        alum.fecha_control_bajada = null;
      } else {
        alum.ausente = 3;
        alum.fecha_control_bajada = Date.now();
        console.log("Baja Bus!");
      }

      console.log("Baja Bus!");
    },

    passengerDetail(tr) {
      //Carga en un modal el componente del detalle de un pasagero/alumno
      this.detallealumno = tr;
      this.isComponentModalActive = true;
      return true;
    },
    previous() {
      this.$store.commit("SET_DETALLERUTA", this.druta);
      this.$router.push("/parada-cole-tarde/" + (parseInt(this.orden) - 1));
    },
    next() {
      this.$store.commit("SET_DETALLERUTA", this.druta);
      this.$router.push("/parada-cole-tarde/" + (parseInt(this.orden) + 1));
    },
    onErrorPic(event, src) {
      console.log(src + " fails to load [" + event.type + "]");
    },
    backParada() {
      this.$router.push(this.$store.getters.navBack.url);
    },
    safeguardingStyle(safeguarding) {
      if (!safeguarding) return { color: "#0046ad" };
      const val = safeguarding.toLowerCase();
      if (val === "high") return { color: "#e00034" };
      if (val === "moderate") return { color: "#ffb612" };
      if (val === "low") return { color: "#00a651" };
      return { color: "#0046ad" };
    }
  },
  data() {
    return {
      isComponentModalActive: false,
      detallealumno: null,
      druta: null,
      imgurl: process.env.VUE_APP_API_URL + process.env.VUE_APP_DIRPIC
    };
  },
  props: ["orden"],
  computed: {
    nombreParada() {
      return this.druta.paradas.filter(pr => pr.orden == this.orden).length > 0
        ? this.druta.paradas.filter(pr => pr.orden == this.orden)[0].nombre
        : "";
    },
    horaParada() {
      //console.log(this.druta.paradas.filter(pr => pr.orden == this.orden));
      return this.druta.paradas.filter(pr => pr.orden == this.orden).length > 0
        ? this.druta.paradas.filter(pr => pr.orden == this.orden)[0].horaf
        : "";
    },
    totalParada() {
      return this.druta
        ? this.druta.trasladados.filter(
            tr =>
              tr.ordenparada == this.orden &&
              (tr.ausente == 2 || tr.ausente == 3)
          ).length
        : 0;
    },
    totalAusentes() {
      return this.druta
        ? this.druta.trasladados.filter(
            tr => tr.ordenparada < 100 && (tr.ausente == 1 || tr.ausente == 4)
          ).length
        : 0;
    },
    totalHanBajado() {
      return this.druta
        ? this.druta.trasladados.filter(
            tr => tr.ordenparada < 100 && tr.ausente == 3
          ).length
        : 0;
    },
    totalHanBajadoParada() {
      return this.druta
        ? this.druta.trasladados.filter(
            tr => tr.ordenparada == this.orden && tr.ausente == 3
          ).length
        : 0;
    },
    trasladadosParada() {
      return this.druta
        ? this.druta.trasladados.filter(
            tr =>
              tr.ordenparada == this.orden &&
              (tr.ausente == 2 || tr.ausente == 3)
          )
        : [];
    },
    trasladadosCambioPuntual() {
      return this.druta
        ? this.druta.trasladados.filter(
            tr => tr.cambiopuntual == 1 && tr.rutaoriginal != this.druta.idruta
          )
        : [];
    },
    totalAusentesRuta() {
      return this.druta
        ? this.druta.trasladados.filter(
            tr => tr.ausente == 1 || tr.ausente == 4
          ).length
        : 0;
    },
    totalRuta() {
      return this.druta
        ? this.druta.trasladados.filter(
            tr => (tr.ausente == 2 || tr.ausente == 3) && tr.ordenparada < 100
          ).length
        : 0;
    }
  },
  beforeDestroy() {
    this.$store.commit("SET_DETALLERUTA", this.druta);
    console.log("Sale de Parada !!!");
  }
};
</script>
